import { render, staticRenderFns } from "./Probenplan.vue?vue&type=template&id=625fc1aa&"
import script from "./Probenplan.vue?vue&type=script&lang=js&"
export * from "./Probenplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports